module.exports = __webpack_public_path__ + "static/media/pic4.73a1a4c2.jpg";